<ae2-seo [title]="'Studio Velocity | Música, alma, suor (tudo junto)'"
    [metaDescription]="'
    Studio Velocity é mais do que uma aula de bike indoor. É conexão entre corpo, mente, música e movimento. São 45min de cardio que transformam de dentro pra fora.'"
    [Keyword]="'Studio Velocity'">
</ae2-seo>
<ae2-carousel-container carouselCode="home" [config]="carouselConfig"></ae2-carousel-container>